import React from "react";
import { useLanguage } from "../../context/LanguageContext";

const SuccessIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M6.5 12.5l4 4 7-8.5"
    />
  </svg>
);

const InfoIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <circle cx="12" cy="7" r="1.3" fill="currentColor" />
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      d="M12 11v7"
    />
  </svg>
);

const WarningIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2.4"
      strokeLinecap="round"
      d="M12 8.5v6"
    />
    <circle cx="12" cy="17.2" r="1.2" fill="currentColor" />
  </svg>
);

const ErrorIcon = () => (
  <svg viewBox="0 0 24 24" aria-hidden="true">
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="2.6"
      strokeLinecap="round"
      d="M8 8l8 8M16 8l-8 8"
    />
  </svg>
);

const ICONS = {
  success: SuccessIcon,
  info: InfoIcon,
  warning: WarningIcon,
  error: ErrorIcon,
};

const TITLE_KEYS = {
  success: "toast.success",
  info: "toast.info",
  warning: "toast.warning",
  error: "toast.error",
};

const Toast = ({
  variant = "success",
  title,
  message,
  details = [],
  onDismiss,
}) => {
  const { t } = useLanguage();
  const Icon = ICONS[variant] || ICONS.info;
  const heading = title || t(TITLE_KEYS[variant] || TITLE_KEYS.info);
  const rich = details.length > 0;

  return (
    <div
      className={`toast toast--${variant}${rich ? " toast--rich" : ""}`}
      role={variant === "error" ? "alert" : "status"}
    >
      <span className={`toast__icon toast__icon--${variant}`}>
        <Icon />
      </span>

      <div className="toast__content">
        <p className="toast__title">{heading}</p>
        {message ? <p className="toast__message">{message}</p> : null}

        {rich ? (
          <dl className="toast__details">
            {details.map((item) => (
              <div
                key={item.label}
                className={`toast__detail${item.wide ? " toast__detail--wide" : ""}`}
              >
                <dt>{item.label}</dt>
                <dd>{item.value || "—"}</dd>
              </div>
            ))}
          </dl>
        ) : null}
      </div>

      <button
        type="button"
        className="toast__close"
        aria-label={t("toast.dismiss")}
        onClick={onDismiss}
      >
        <svg viewBox="0 0 16 16" aria-hidden="true">
          <path
            fill="none"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            d="M4 4l8 8M12 4l-8 8"
          />
        </svg>
      </button>
    </div>
  );
};

export default Toast;
